import { useAuth } from "../context/AuthContext";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";
import { Shield, Mail, User as UserIcon, LogOut, Calendar } from "lucide-react";

export default function Profile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;
  const initial = (user.name || user.email)[0]?.toUpperCase();

  return (
    <div className="min-h-screen bg-ink relative">
      <SEO title="Perfil" path="/profile" />
      <div className="fixed inset-0 bg-aurora pointer-events-none" />
      <div className="relative">
        <Header />
        <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-14">
          <div className="text-xs font-bold uppercase tracking-[0.22em] text-gcgold mb-3 font-mono">Perfil</div>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-white tracking-tighter leading-[0.95]">Tu cuenta</h1>

          <div className="mt-10 bg-ink-800 border border-white/5 rounded-3xl p-7">
            <div className="flex items-center gap-5">
              <div className="h-20 w-20 rounded-2xl bg-gradient-to-br from-gcgreen to-gcgreen-dark flex items-center justify-center font-display text-3xl font-extrabold text-gcgold border border-gcgold/30">
                {initial}
              </div>
              <div>
                <div className="font-display text-2xl font-bold text-white tracking-tight" data-testid="profile-name">{user.name}</div>
                <div className="text-sm text-slate-400" data-testid="profile-email">{user.email}</div>
                <div className="mt-2 inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.22em] font-bold text-gcgold bg-gcgold/10 border border-gcgold/30 px-2 py-0.5 rounded-md font-mono">{user.role}</div>
              </div>
            </div>

            <div className="mt-8 space-y-2.5 text-sm">
              <div className="flex items-center gap-3 p-3 bg-white/[0.02] rounded-xl border border-white/5">
                <UserIcon className="h-4 w-4 text-slate-500" />
                <span className="text-slate-300">{user.name}</span>
              </div>
              <div className="flex items-center gap-3 p-3 bg-white/[0.02] rounded-xl border border-white/5">
                <Mail className="h-4 w-4 text-slate-500" />
                <span className="text-slate-300">{user.email}</span>
              </div>
              <div className="flex items-center gap-3 p-3 bg-white/[0.02] rounded-xl border border-white/5">
                <Calendar className="h-4 w-4 text-slate-500" />
                <span className="text-slate-300">Cuenta creada el {new Date(user.created_at).toLocaleDateString("es-ES")}</span>
              </div>
            </div>

            <Button
              variant="outline"
              onClick={async () => { await logout(); navigate("/"); }}
              className="mt-8 bg-red-950/30 border-red-700/30 text-red-300 hover:bg-red-900/40 hover:text-red-200 rounded-xl"
              data-testid="profile-logout"
            >
              <LogOut className="h-4 w-4 mr-2" /> Cerrar sesión
            </Button>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}
